<script setup lang="ts">
import { useArticleFont } from "@/common/composables/use-article-font.composable";
import { mergeInflections } from "@/components/article/dictsys/inflectionSchemes/german/merge-inflections";
import type { DictsysInflectionSchemeContent } from "@/types/article-formats/dictsys";

defineProps<{
  inflections: DictsysInflectionSchemeContent[];
}>();

const { articleFontClass } = useArticleFont();
</script>

<template>
  <span class="inflection-scheme-cell-highlight" :class="articleFontClass">
    <span v-if="inflections[0].prefix" class="inflection-scheme-cell-highlight__prefix"
      >{{ inflections[0].prefix }}{{ " " }}</span
    >
    <span
      ><slot>{{ mergeInflections(inflections) }}</slot></span
    >
  </span>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.inflection-scheme-cell-highlight {
  word-wrap: break-word;

  &__prefix {
    color: rgb(@theme-colors[@secondary][base]);
    font-weight: 700;
  }
}
</style>
